import React from 'react'
import { useTranslation } from 'react-i18next'

export const SpotCrowdedLabel = ({ spotCrowded, w = 'w-20' }: { spotCrowded: Api.SpotCrowded; w?: string }) => {
  const { t } = useTranslation()

  const bgColor =
    spotCrowded === 'EMPTY'
      ? 'bg-blue-400'
      : spotCrowded === 'CROWDED'
        ? 'bg-red-300'
        : spotCrowded === 'FULL'
          ? 'bg-red-400'
          : spotCrowded === 'CLOSURE'
            ? 'bg-red-200'
            : 'bg-gray-200'
  const textColor =
    spotCrowded === 'EMPTY' || spotCrowded === 'CROWDED' || spotCrowded === 'FULL' || spotCrowded === 'CLOSURE'
      ? 'text-white'
      : 'text-black'
  return (
    <p
      className={`inline-block text-xss text-center font-bold px-2 pt-[0.1rem] pb-[0.1rem] rounded ${w} overflow-hidden text-ellipsis whitespace-nowrap ${bgColor} ${textColor}`}
    >
      {spotCrowded === 'EMPTY' && <>{t('spot_label.empty', '空車')}</>}
      {spotCrowded === 'CROWDED' && <>{t('spot_label.crowded', '混雑')}</>}
      {spotCrowded === 'FULL' && <>{t('spot_label.full', '満車')}</>}
      {spotCrowded === 'CLOSURE' && <>{t('spot_label.closed', '休止')}</>}
      {spotCrowded === 'UNKNOWN' && <>{t('spot_label.unknown', '不明')}</>}
    </p>
  )
}
